module.exports = __webpack_public_path__ + "static/media/purco-banner.e7fea726.jpg";